import React, {Component} from "react";
import PropTypes from "prop-types";
import moment from "moment";
import {SingleDatePicker} from "react-dates";
import classNames from "classnames";
import {_setMembershipV2} from "../../../../../services/apis/AdminServices";
import styles from "./SetMembership.scss";

class SetMembership extends Component {
    state = {
        dateFinish: moment(),
        total: 0,
        focused: false,
        result: null
    };

    render() {
        const {focused, dateFinish, total} = this.state;

        return (
            <td>
                <div className={styles.wrapper}>
                    <div className={classNames(styles.finish, "d-flex justify-content-between")}>
                        <label>Finish date:</label>

                        <SingleDatePicker
                            date={dateFinish}
                            focused={focused}
                            onFocusChange={this._handleOnFocused}
                            onDateChange={this._handleOnChangeDate}/>
                    </div>

                    <div className="price d-flex justify-content-between">
                        <label>Price ($)</label>
                        <input min={0}
                               className="form-control"
                               onChange={this._onChangeTotal}
                               value={total}
                               type="number"/>
                    </div>

                    <button onClick={this._onClickSubmit} className={classNames(styles.submit, "btn btn-primary")}>Set
                        membership
                    </button>
                </div>
            </td>
        );
    }

    _onClickSubmit = (e) => {
        e.preventDefault();

        const {dateFinish, total} = this.state;
        const {userId} = this.props;

        _setMembershipV2({
            finish: dateFinish.format('DD/MM/YYYY'),
            price: parseInt(total, 10) || 0,
            userId
        }).then(result => {
            this.props.onChange && this.props.onChange();
        });
    };

    _onChangeTotal = (e) => {
        const {value} = e.target;

        this.setState({
            total: value
        });
    };

    _handleOnFocused = () => {
        this.setState({
            focused: !this.state.focused
        });
    };

    _handleOnChangeDate = (date) => {
        this.setState({
            dateFinish: date
        });
    }
}

SetMembership.propTypes = {
    userId: PropTypes.string,
    onChange: PropTypes.func
};

export default SetMembership;


// WEBPACK FOOTER //
// ./src/app/pages/dashboard/user/SetMembership/SetMembership.js